import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { config } from '../config';

export interface AuditCatalogTaskState {
  taskId: string;
  name: string;
  enabled: boolean;
  intervalSeconds: number;
  severity: string;
  lastRunAt: string | null;
  alertState: string;
}

export interface AuditCatalogEntry {
  auditType: string;
  displayName: string;
  description: string;
  defaultIntervalSeconds: number;
  defaultSeverity: string;
  defaultParams: unknown;
  alertDefinition: AuditCatalogTaskState | null;
}

interface AuditCatalogResponse {
  entries: AuditCatalogEntry[];
}

export function useAuditCatalog() {
  return useQuery<AuditCatalogEntry[]>({
    queryKey: ['auditCatalog'],
    queryFn: async () => {
      const response = await axios.get<AuditCatalogResponse>(
        `${config.backendApi}/api/admin/audit-catalog/`,
        { withCredentials: true }
      );
      return response.data.entries;
    },
  });
}

export function useSeedDefaultAudits() {
  const queryClient = useQueryClient();
  return useMutation<{ inserted: boolean }>({
    mutationFn: async () => {
      const response = await axios.post<{ inserted: boolean }>(
        `${config.backendApi}/api/admin/audit-catalog/seed-defaults`,
        {},
        { withCredentials: true }
      );
      return response.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['auditCatalog'] });
      void queryClient.invalidateQueries({ queryKey: ['alertDefinitions'] });
    },
  });
}
